import type { Patient } from "@louise/medical-history/basic-info/calculateBasicInfoCompletion";

export function calculateDietSupplementsCompletion(
  patient: Patient | null | undefined,
) {
  const lifestyle = (patient as any)?.lifestyle;

  // Step 1: Has diet answer
  const hasDietsFlag = lifestyle?.hasDiets;
  const diets = lifestyle?.diets;
  const hasDietAnswer =
    (hasDietsFlag !== undefined && hasDietsFlag !== null) ||
    (Array.isArray(diets) && diets.length > 0);
  const hasDietDetails =
    hasDietsFlag === false || (Array.isArray(diets) && diets.length > 0);

  // Step 2: Has supplements answer
  const hasSupplementsFlag = lifestyle?.hasDietSupplements;
  const supplements = lifestyle?.dietSupplements;
  const hasSupplementAnswer =
    (hasSupplementsFlag !== undefined && hasSupplementsFlag !== null) ||
    (Array.isArray(supplements) && supplements.length > 0);
  const hasSupplementDetails =
    hasSupplementsFlag === false ||
    (Array.isArray(supplements) && supplements.length > 0);

  const total = 4;
  const completed =
    (hasDietAnswer ? 1 : 0) +
    (hasDietDetails ? 1 : 0) +
    (hasSupplementAnswer ? 1 : 0) +
    (hasSupplementDetails ? 1 : 0);
  const percent = completed / total;
  const label = `${completed}/${total} answered`;

  return { percent, label, completed, total };
}
